<template>
  <div class="arch-items-container btns4">
    <button
      v-for="(step, index) in steps"
      :key="index"
      class="arch-item"
      @click="goToStep(index)"
      :class="{ active: activeStep === index }"
    >
      {{ step }}
    </button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //activeStep: 'step1'
    }
  },
  props: {
    steps: Array,
    activeStep: Number
  },
  methods: {
    goToStep(step) {
      //this.activeStep = step
      this.$emit('go-to-step', step)
    }
  },
  computed: {}
}
</script>
<style lang="scss" scoped>
@use '../sass/helpers/_mixins.scss' as *;
@use '../sass/base/_colors.scss' as *;

.arch-items-container {
  margin-left: 0;
  display: none;
  align-items: center;
  pointer-events: none;
}
.arch-item {
  @include eclipse(80px);
  background-color: var(--arch-color);
  box-shadow: var(--default-shadow);
  color: var(--arch-text-color);
  font-size: 11px;
  font-weight: 500;
  padding: 0;
  transition: 0.3s all;
  transform: scale(0, 0);
  animation: archbtn 0.25s ease-out forwards;
  margin-right: 5px;
  pointer-events: auto;

  @keyframes archbtn {
    to {
      transform: scale(1, 1);
    }
  }

  &.active {
    @include eclipse(90px);

    background-color: var(--main-color);

    &:hover {
      box-shadow: var(--default-shadow-hover);
    }
  }

  &:nth-of-type(1) {
    animation-delay: 0.25s;
  }

  &:nth-of-type(2) {
    animation-delay: 0.35s;
  }

  &:nth-of-type(3) {
    animation-delay: 0.45s;
  }

  &:nth-of-type(4) {
    animation-delay: 0.55s;
  }
}

@media only screen and (min-width: 1024px) {
  .arch-items-container {
    justify-content: flex-start;
    display: flex;
    position: relative;
    left: -88px;
    top: 23px;
    font-size: 12px;
    height: 120px;
  }

  .arch-item {
    &:hover {
      box-shadow: var(--default-shadow-hover);
      @include eclipse(90px);
    }

    &.active {
      @include eclipse(100px);
      font-size: 0.82rem;
    }

    &:nth-of-type(2) {
      margin-top: -122px;
      margin-left: -11px;
    }
    &:nth-of-type(3) {
      margin-top: -188px;
      margin-left: 5px;
    }

    &:nth-of-type(4) {
      margin-top: -170px;
      margin-left: 8px;
    }
  }
}
</style>
